module.exports = require("xml");


//////////////////
// WEBPACK FOOTER
// external "xml"
// module id = 479
// module chunks = 0